/* ------------------------------------------------------------------------
   Product Page - Product Detail Labels
   ------------------------------------------------------------------------ */

document.addEventListener("DOMContentLoaded", function () {
  const descriptions = document.querySelectorAll(
    ".product-description-wrapper"
  );

  descriptions.forEach(function (description) {
    const paragraphs = description.querySelectorAll("p");

    paragraphs.forEach(function (paragraph) {
      const paragraphText = paragraph.textContent.trim();

      const match = paragraphText.match(
        /^(Materials?|Measurements?|Place of Origin)\s*:/i
      );

      if (!match) return;

      const labelText = match[1];

      const walker = document.createTreeWalker(
        paragraph,
        NodeFilter.SHOW_TEXT
      );

      const textNodes = [];

      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      let labelRemoved = false;
      let colonRemoved = false;

      textNodes.forEach(function (node) {
        if (!labelRemoved) {
          const labelRegex = new RegExp(
            "^\\s*" + labelText.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
            "i"
          );

          if (labelRegex.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(
              labelRegex,
              ""
            );

            labelRemoved = true;
          }
        }

        if (labelRemoved && !colonRemoved) {
          if (/^\s*:/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(
              /^\s*:/,
              ""
            );

            colonRemoved = true;
          }
        }
      });

      const label = document.createElement("span");
      label.className = "product-detail-label";
      label.textContent = labelText + ":";

      paragraph.insertBefore(
        label,
        paragraph.firstChild
      );
    });
  });
});


/* ------------------------------------------------------------------------
   Silver Editorial - Disable CT, ET & ST Ligatures
   ------------------------------------------------------------------------ */

document.addEventListener("DOMContentLoaded", function () {
  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT
  );

  const textNodes = [];

  while (walker.nextNode()) {
    textNodes.push(walker.currentNode);
  }

  textNodes.forEach(function (node) {
    const parent = node.parentElement;

    if (!parent) return;

    /* Only process text containing CT, ET, or ST */
    if (!/(ct|et|st)/i.test(node.nodeValue)) return;

    const fontFamily = window
      .getComputedStyle(parent)
      .fontFamily
      .toLowerCase();

    /* Only affect Silver Editorial */
    if (!fontFamily.includes("silver editorial")) return;

    /* Break CT, ET, and ST ligatures */
    node.nodeValue = node.nodeValue.replace(
      /(ct|et|st)/gi,
      function (match) {
        return match.charAt(0) + "\u200C" + match.charAt(1);
      }
    );
  });
});

/* ------------------------------------------------------------------------
   Contact Form - Required Asterisks
   ------------------------------------------------------------------------ */

document.addEventListener("DOMContentLoaded", function () {
  const labels = document.querySelectorAll(
    ".section-contact-form .contact-form--form label"
  );

  labels.forEach(function (label) {
    if (!label.textContent.trim().startsWith("*")) return;

    label.innerHTML = label.innerHTML.replace(
      "*",
      '<span class="required-asterisk">*</span>'
    );
  });
});

/* ------------------------------------------------------------------------
   Blog Main - Manrope Regular for Subtitles
   ------------------------------------------------------------------------ */
document.querySelectorAll('#blog_posts .blog-title-wrapper h3 a').forEach(title => {
  const text = title.textContent.trim();
  const colonIndex = text.indexOf(':');

  if (colonIndex === -1) return;

  const mainTitle = text.slice(0, colonIndex + 1);
  const subtitle = text.slice(colonIndex + 1).trim();

  title.innerHTML =
    `${mainTitle} <span class="blog-title-subtitle">${subtitle}</span>`;
});

/* Adornment + Theory - Custom Section Classes */
(function () {
  function applyAtCustomClasses(root) {
    var scope = root || document;
    var markers = scope.querySelectorAll ? scope.querySelectorAll('[data-at-custom-class]') : [];

    markers.forEach(function (marker) {
      var section = marker.closest('.shopify-section');
      if (!section) return;

      var classes = (marker.getAttribute('data-at-custom-class') || '')
        .split(/\s+/)
        .filter(Boolean);

      classes.forEach(function (className) {
        section.classList.add(className);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyAtCustomClasses(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    applyAtCustomClasses(event.target || document);
  });
})();
